import { useState, useEffect, useRef, lazy, Suspense } from "react";
import "./UserMonthAttendance.css";
import { connect } from "react-redux";
import uiActions from "../../../../../redux/ui/action";
import authActions from "../../../../../redux/auth/action";
import userPreferenceActions from "../../../../../redux/user_preference/action";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import axios from "axios";
import images from "../../../../../utilities/images/images";
import LoaderPopUp from "../../../../../components/loader/loader";

const StudentMonthAttendanceContent = lazy(() =>
  import(
    "../../../../../parent/user-attendance/monthWiseAttendance/StudentMonthAttendanceContent"
  )
);

const UserMonthAttendance = (props) => {
  const { startLoading, finishLoading, rollNo, loader } = props;

  const [startDate, setStartDate] = useState(() => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  });

  const [endDate, setEndDate] = useState(new Date());
  const [attendanceData, setAttendanceData] = useState({});
  const [dateError, setDateError] = useState("");

  const debounceRef = useRef(null);
  const prevPayload = useRef(null);
  const loaderTimeoutRef = useRef(null);

  useEffect(() => {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(() => getAttendanceDetails());
    } else {
      setTimeout(() => getAttendanceDetails(), 0);
    }
  }, []);

  const getAttendanceDetails = async () => {
    const payload = {
      startDate: format(startDate, "yyyy-MM-dd"),
      endDate: format(endDate, "yyyy-MM-dd"),
      rollNo: rollNo,
    };

    if (
      prevPayload.current &&
      JSON.stringify(prevPayload.current) === JSON.stringify(payload)
    ) {
      return;
    }

    prevPayload.current = payload;

    loaderTimeoutRef.current = setTimeout(() => {
      startLoading();
    }, 300);

    try {
      const response = await axios.post(
        "https://bg.mescray001.com/api/v1/zoom-attendance/get-student-attendance-monthwise-mla",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data) {
        setAttendanceData(response.data);
      } else {
        setAttendanceData({});
      }
    } catch (error) {
      console.error("API Error:", error);
      setAttendanceData({});
    } finally {
      clearTimeout(loaderTimeoutRef.current);
      finishLoading();
    }
  };

  const handleClick = () => {
    if (startDate > endDate) {
      setDateError("Start date should not be after end date.");
      return;
    }

    setDateError("");
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      getAttendanceDetails();
    }, 500);
  };

  return (
    <>
      <div className="student-activity-wrapper">
        <div className="container_grey_box">
          <div className="bckBtn-title">
            <Link className="backBtn" to="/user_dashboard">
              <img src={images.m2_backBtn} alt="backBtn" />
            </Link>
            <div className="content-head">
              <h1>Student Attendance</h1>
            </div>
          </div>

          <div className="range_div">
            <div className="left">
              <p>Data showing from</p>
              <p>Search by specific date</p>
            </div>
            <div className="right">
              <div className="date">
                <p>From</p>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  dateFormat="dd MMM yyyy"
                  maxDate={new Date()}
                />
              </div>
              <div className="date">
                <p>To</p>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  dateFormat="dd MMM yyyy"
                  maxDate={new Date()}
                />
              </div>
              <button onClick={handleClick}>Continue</button>
              {dateError && (
                <p style={{ color: "red", marginTop: "0.5rem" }}>{dateError}</p>
              )}
            </div>
          </div>

          <Suspense fallback={<div>Loading attendance data...</div>}>
            <StudentMonthAttendanceContent attendanceData={attendanceData} />
          </Suspense>
        </div>
      </div>
      {loader && <LoaderPopUp />}
    </>
  );
};

const mapStateToProps = (state) => ({
  loader: state.ui.loader,
  token: state.auth.authToken,
  tokenType: state.auth.authType,
  currentRefundPackage: state.RefundPackageSliceReducer.refundCurrentPackage,
  rollNo: state.auth.user.roll_no,
});

const mapDispatchToProps = (dispatch) => ({
  startLoading: () => dispatch(uiActions.startLoading()),
  finishLoading: () => dispatch(uiActions.finishLoading()),
  setUser: (payload) => dispatch(authActions.setUser(payload)),
  setUserPreference: (payload) =>
    dispatch(userPreferenceActions.setUserPreference(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserMonthAttendance);
